export function imageChangeSize(file: File, maxSize = 200): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = e => {
      if (!e.target?.result) return reject('Error load file');
      img.src = e.target.result as string;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject('Canvas not support!');

      canvas.width = maxSize;
      canvas.height = maxSize;

      // ctx.fillStyle = 'white';
      // ctx.fillRect(0, 0, maxSize, maxSize);

      const { width, height } = img;

      const scale = Math.min(maxSize / width, maxSize / height);
      const newWidth = width * scale;
      const newHeight = height * scale;

      const dx = (maxSize - newWidth) / 2;
      const dy = (maxSize - newHeight) / 2;

      ctx.drawImage(img, dx, dy, newWidth, newHeight);

      canvas.toBlob(blob => {
        if (!blob) return reject('Error create Blob');
        resolve(new File([blob], file.name, { type: file.type }));
      }, file.type);
    };

    reader.onerror = () => reject('Error read file');
    reader.readAsDataURL(file);
  });
}

export const canvasToImage = (canvas: HTMLCanvasElement) => {
  const img = document.createElement('img');
  img.src = canvas.toDataURL('image/png');
  img.style.width = canvas.style.width || 'auto';
  img.style.height = canvas.style.height || 'auto';
  return img;
};
